import React from "react";
import MemberComponent from "../components/becomeAmember/index";
import SeoMeta from "../components/meta";

export default function BecomeMember() {
  return (
    <>
      <SeoMeta
        title="Become a member | FameWheels"
        desc="Become a member to bid on your dream car, Find the car of your dreams at a fraction of the price with car live bidding. From stylish sedans to tough off-roaders. Don't miss out, Bid now and save big."
        url="become-a-member"
      />

      <MemberComponent />
    </>
  );
}
